import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "footer", "link" ]

  initialize() {
  }

  connect() {
    const currentId = this.element.closest('[data-current-employee-id]').dataset.currentEmployeeId;
    const cardId = this.element.dataset.employeeId;

    if (currentId === cardId) {
      this.element.querySelectorAll('.clock-in-btn, .clock-out-btn').forEach(el => el.remove());
    }
  }

  // Actions

  toggleFooter() {
    this.footerTarget.classList.toggle("d-none")
  }
};
